import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoServiceService } from '@xref/ngx';

@Component({
    selector: 'xqnr-get-started',
    templateUrl: './get-started.component.pug',
    styleUrls: ['./get-started.component.scss'],
    standalone: false
})
export class GetStartedComponent implements OnInit {
  constructor(
    private router: Router,
    private seoService: SeoServiceService,
    private activatedRouter: ActivatedRoute
  ) {}

  ngOnInit() {
    // Update meta tags
    this.activatedRouter.data.subscribe((data) => {
      this.seoService.updateDescription(data.description);
      this.seoService.updateTitle(data.title);
    });
  }

  formCancel() {
    this.router.navigate(['/']);
  }
}
